<script>
import { VueRecaptcha } from 'vue-recaptcha';
import Modal from '@/components/modules/Modal.vue';
import AjaxForm from '@/components/elements/AjaxForm.vue';

export default {
    name: 'ContactLink',
    methods: {
        openModal () {
            this.$refs.modal.openModal();
        }
    },
    components: {
        VueRecaptcha,
        Modal,
        AjaxForm
    }
};
</script>